module.exports = __webpack_public_path__ + "public/static/img/img-section2-7.0f3ca8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section2-7.svg
// module id = kTsS
// module chunks = 1